"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _LifecycleExpiration_1 = require("./_LifecycleExpiration");
var _LifecycleRuleFilter_1 = require("./_LifecycleRuleFilter");
var _TransitionList_1 = require("./_TransitionList");
var _NoncurrentVersionTransitionList_1 = require("./_NoncurrentVersionTransitionList");
var _NoncurrentVersionExpiration_1 = require("./_NoncurrentVersionExpiration");
var _AbortIncompleteMultipartUpload_1 = require("./_AbortIncompleteMultipartUpload");
exports._LifecycleRule = {
    type: "structure",
    required: ["Status"],
    members: {
        Expiration: {
            shape: _LifecycleExpiration_1._LifecycleExpiration
        },
        ID: {
            shape: {
                type: "string"
            }
        },
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Filter: {
            shape: _LifecycleRuleFilter_1._LifecycleRuleFilter
        },
        Status: {
            shape: {
                type: "string"
            }
        },
        Transitions: {
            shape: _TransitionList_1._TransitionList,
            locationName: "Transition"
        },
        NoncurrentVersionTransitions: {
            shape: _NoncurrentVersionTransitionList_1._NoncurrentVersionTransitionList,
            locationName: "NoncurrentVersionTransition"
        },
        NoncurrentVersionExpiration: {
            shape: _NoncurrentVersionExpiration_1._NoncurrentVersionExpiration
        },
        AbortIncompleteMultipartUpload: {
            shape: _AbortIncompleteMultipartUpload_1._AbortIncompleteMultipartUpload
        }
    }
};
//# sourceMappingURL=_LifecycleRule.js.map